<template>
    <b-button class="mx-1" :variant="buttonVariant" size="sm" @click="toggleArchiveState">
        <span :class="buttonFaIcon"></span>
        <span style="white-space: nowrap;">{{ buttonText }}</span>
    </b-button>
</template>

<script>
export default {
    name: "ArchiveButton",
    props: {
        uploadedFile: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            textArchive: 'Archive',
            textRestore: 'Restore',
            recentAction: null,
        }
    },
    mounted() {

    },
    computed: {
        isArchived: function () {
            let archivedState = !!this.uploadedFile.archive_date;
            if (this.recentAction === 'archive') {
                archivedState = true;
            } else if (this.recentAction === 'restore') {
                archivedState =false;
            }
            return archivedState;
        },
        buttonText: function () {
            let text = this.textArchive;
            if (this.isArchived) {text = this.textRestore}
            return text;
        },
        buttonFaIcon: function () {
            let iconClass = 'fa fa-archive';
            if (this.isArchived) {iconClass = 'fa fa-tag'}
            return iconClass;
        },
        buttonVariant: function () {
            let variant = 'outline-danger';
            if (this.isArchived) {variant = 'outline-info'}
            return variant;
        },
    },
    methods: {
        toggleArchiveState: function () {
            let id = this.uploadedFile.id;
            if (this.isArchived) {
                /** Restore */
                this.restoreUploadFile(id);
            } else {
                /** Archive */
                this.archiveUploadFile(id);
            }
        },
        archiveUploadFile: function (id) {
            axios.post('/api/file-archive/' + id)
                .then(response => {
                    let status = response.data;
                    this.recentAction = 'archive'
                })
                .catch(error => {
                    // console.log(error);
                })
        },
        restoreUploadFile: function (id) {
            axios.post('/api/file-restore/' + id)
                .then(response => {
                    let status = response.data;
                    this.recentAction = 'restore'
                })
                .catch(error => {
                    // console.log(error);
                })
        },
    }
}
</script>

<style scoped>

</style>
